import { Component } from 'react'
import type { ReactNode } from 'react'

/**
 * Scopes @git-diff-view failures to the diff view instead of the app-level
 * boundary. Lives in its own eagerly-imported module (NOT the lazy DiffViewer
 * chunk) so it also catches a failed dynamic import() of that chunk — e.g. a
 * stale content-hashed chunk 404 after a deploy. Mirrors MilkdownErrorBoundary.
 */
export class DiffErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { hasError: boolean }
> {
  override state = { hasError: false }
  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true }
  }
  override render() {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
